import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LoginHeader from '../Layout/LoginHeader';
import image from "../Images/bg.jpg";
import toast from 'react-hot-toast';
import HttpClient from '../utils/HttpClient';
import { reactLocalStorage } from 'reactjs-localstorage';
import { confirmAlert } from 'react-confirm-alert';

const ResetPassword = () => {
    const location = useLocation()
    const [email, setEmail] = useState(location.state?.email);
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const isValid = email.trim() !== "" && password.trim() !== "";
    //     if (isValid) {
    //         // toast.success("login successfully")
    //         if (!email.match(mailFormat)) {
    //             toast.error("Invalid Email");
    //         } else {
    //             const data = {
    //                 emailId: email,
    //                 password: password,
    //             };
    //             const res = await HttpClient.requestData("login", "POST", data);
    //             if (res && res.status) {

    //                 if (res?.data?.suspendStatus) {
    //                     // setModal(true)
    //                     return
    //                 }

    //                 reactLocalStorage.set("userDataNeoCard", res?.data?.token);
    //                 reactLocalStorage.set(
    //                     "userDataNeoCardMemberStatus",
    //                     JSON.stringify({ MemberStatus: res?.data?.memberStatus })
    //                 );

    //                 // return
    //                 if (res?.data?.memberStatus === true) {
    //                     toast.success("Login Successfully");
    //                     setEmail("");
    //                     setPassword("");
    //                     // firebase chat set

    //                     navigate("/profile/" + res?.data?.userName?.trim());
    //                     // navigate("/profile/" + res?.data?._id);

    //                     // window.location.reload();
    //                 } else {
    //                     navigate("/NonMemberuserprofile/" + res?.data?.personName?.trim()?.replace(/ /g, "_"));
    //                     toast.success("Login Successfully");
    //                     setEmail("");
    //                     setPassword("");
    //                     // window.location.reload();
    //                 }
    //             } else {
    //                 // toast.error(res?.message);
    //                 confirmAlert({
    //                     // title: "Confirm to delete",
    //                     // message: `Are you sure you want to delete "${item}"?`,
    //                     title: (
    //                         <h4 style={{ color: "#ff0000" }}>Sorry</h4>
    //                     ),
    //                     message: (
    //                         <>
    //                             <p>{res?.message}</p>
    //                             <p>Please contact web administrator for further details.</p>
    //                         </>
    //                     ),
    //                     buttons: [
    //                         {
    //                             label: "Help Center",
    //                             onClick: () => navigate("/lets-get-intouch"),
    //                             style: { background: "#009E60" },
    //                         },
    //                         // {
    //                         //   label: "No",
    //                         //   onClick: () => alert("Action canceled!"),
    //                         // },
    //                     ],
    //                 });
    //                 // navigate("/activate-neoocard");
    //             }
    //         }
    //     } else {
    //         toast.error("Please fill all the Inputs..");
    //     }
    // };

    return (
        <>
            <section className="authenSec">
                <div className="authenSecInn">
                    <div className="container">
                        <div className="authenSecInnDiv">
                            <div className="authenSecForm">
                                <div className="authenSecTop">
                                    {/* <p className='resetmsg'><i class="fa-solid fa-triangle-exclamation"></i>Check your email <strong>{email}</strong> for the password reset link</p> */}
                                    <div className='forgetFig'>
                                    </div>
                                    {/* <h4>Reset Password</h4>
                                    <p>Please enter your username or email address. A new password has been mailed to you.</p> */}
                                    <h4>Success</h4>
                                    <p>A link to reset your password has been sent to your registered email address with subject Neoo Search Password Reset.</p>
                                </div>

                                <div className='p-4'>
                                    <div className='mb-2'>
                                        <Link to="/user-login">
                                            <i className="fa-regular fa-circle-right mr-2"></i>
                                            Log In to your account
                                        </Link>

                                    </div>
                                    <div >
                                        <Link to="/forgotPassword">
                                            <i className="fa-regular fa-circle-right mr-2"></i>
                                            Forgot Password ?
                                        </Link>
                                    </div>
                                </div>

                                {/* <div className="authenSecBtm">
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <input type="email" placeholder='Email Id'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input type="password" placeholder='Password'
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                        </div>
                                        <button type='submit' to='/Memberownprofile' className='homeloginBtn'>Submit</button>
                                    </form>
                                </div> */}

                            </div>
                            <div className="authenSecImg">
                                <img src={image} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ResetPassword